import React from 'react';
import { Newspaper, Clock } from 'lucide-react';

import { timeAgo } from '../utils'; // Utility function to format time

export const NewsCard = ({ article, onOpenRead }) => {
    const img = article.thumbnailUrl || article.image || null;

    return (
        <article className="bg-gradient-to-br from-slate-800 via-slate-800 to-slate-900 backdrop-blur-md rounded-xl shadow-xl overflow-hidden transform hover:-translate-y-2 hover:shadow-2xl hover:shadow-teal-500/20 transition-all duration-300 border border-teal-500/10 group">
            <div className="md:flex">
                <div className="md:flex-shrink-0 md:w-56 lg:w-64 relative overflow-hidden">
                    {img ? (
                        <>
                            <img
                                src={img}
                                alt={article.title || 'News image'}
                                loading="lazy"
                                className="w-full h-52 md:h-full object-cover rounded-t-xl md:rounded-l-xl md:rounded-tr-none group-hover:scale-110 transition-transform duration-500"
                            />
                            <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
                        </>
                    ) : (
                        <div className="w-full h-52 md:h-full bg-gradient-to-br from-slate-700 to-slate-600 flex items-center justify-center text-gray-400 rounded-t-xl md:rounded-l-xl md:rounded-tr-none group-hover:from-slate-600 group-hover:to-slate-500 transition-colors duration-300">
                            <Newspaper size={40} />
                        </div>
                    )}
                </div>
                <div className="p-6 flex-1 flex flex-col justify-between">
                    <div>
                        <div className="flex items-center text-sm text-teal-300 mb-3 font-semibold">
                            <div className="w-2 h-2 bg-teal-400 rounded-full mr-2"></div>
                            <span>{article.source}</span>
                        </div>
                        <h3 className="text-xl md:text-2xl font-bold text-white mb-3 leading-tight group-hover:text-teal-300 transition-colors duration-300">{article.title}</h3>
                        <p className="text-gray-300 text-base mb-4 line-clamp-3 leading-relaxed">{article.summary}</p>
                    </div>
                    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between text-xs text-gray-400 pt-4 border-t border-gray-700/50">
                        <div className="flex items-center mb-4 sm:mb-0 font-medium">
                            <Clock size={14} className="mr-2 text-teal-400"/>
                            <span>{timeAgo(article.publishedAt)}</span>
                        </div>
                        <div className="flex items-center space-x-3">
                            <button
                                onClick={() => onOpenRead && onOpenRead(article)}
                                className="bg-transparent border-2 border-teal-500 text-teal-300 px-4 py-2 rounded-lg text-sm font-bold hover:bg-teal-500/20 hover:border-teal-400 transition-all duration-200 shadow-md hover:shadow-teal-500/30"
                                aria-label={`Open reader for ${article.title}`}
                            >
                                পড়ুন
                            </button>
                            <a
                                href={article.url}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="bg-gradient-to-r from-teal-500 to-cyan-500 text-white px-5 py-2 rounded-lg text-sm font-bold hover:from-teal-600 hover:to-cyan-600 transition-all duration-200 shadow-lg hover:shadow-teal-500/50"
                                aria-label={`Open article: ${article.title}`}
                            >
                                সম্পূর্ণ পড়ুন
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div className="h-1 bg-gradient-to-r from-transparent via-teal-500/50 to-transparent group-hover:via-teal-400 transition-colors duration-300"></div>
        </article>
    );
};